import React, { Component } from 'react';
import {Helmet} from "react-helmet";
import queryString from 'query-string';
import '../../style/index.scss';
import EventManager from '../../ui/template/Event/EventManager.js';
import Loading from "../../ui/template/Loading/Loading";
import SideBar from "../Layout/SideBar";
import Alerts from "../../ui/template/Alert/Alerts";
import Dispatcher from "../../ui/template/Dispatcher"; 
import PageTitle from "../../ui/template/Breadcrumbs/PageTitle";
import WindowBCChannel from "../../ui/template/Browser/WindowBCChannel";
import Main from "./Main";
import { MCbrowser } from '../Context/browserContext';
import getMember from "./Dashboard/Api/getMember";
 

//document.body.classList.add('rtl') ;

class App extends Component{

    constructor(props) {
        super(props);
        this.Hrefresh = this.refresh.bind(this);
        this.HappChannel = this.appChannel.bind(this);
        this.event = new EventManager();
        this.customCaptionBar=false;
        this.state = {loaded: false,theme: 'default',isLogout: false,render:false};
        this.pageAlerts=React.createRef();
        let d1=new Dispatcher(); 
        this.pageTitle=new PageTitle();
        this.pageTitle.setTitle("ناحیه کاربری ");
        this.pageTitle.addCallBacks(this.Hrefresh);
        this.bc = new WindowBCChannel('app_channel',this.HappChannel);
        this.callmode="";
        const  search  = window.location.search;
        const qusValues = queryString.parse(search);
        if (Boolean(qusValues.callmode)) {
            this.callmode = qusValues.callmode;
        }
        this.page = {pageBC:this.bc,pageTitle:this.pageTitle,pageAlerts:this.pageAlerts,
            dispatcher:d1,pageBreadcrumbs:null,
			callmode:this.callmode};
        this.props=props;
    }

    appChannel(obj) {
        switch (obj.command) {
            case "close":
                window.close();
                break;
            default:
                break;
        }
    }

    refresh() {
        let r=!this.state.render;
        this.setState({ render: r });
    }


    async getLoad() {
        let data = await getMember();
        if (data === false) {
            this.setState({loaded: true });
        } else {
            let firstName="";
            if(data.firstName!=null)  firstName = data.firstName;

            let lastName="";
            if(data.lastName!=null)  lastName = data.lastName;

            let username="";
            if(data.username!=null)  username = data.username;

            let follower="";
            if(data.follower!=null)  follower = data.follower;

            let following="";
            if(data.following!=null)  following = data.following;

            let isShora=false;
            if(data.isShora!=null)  isShora = data.isShora;

            this.context.memberObj={firstName:firstName,lastName:lastName,username:username,
                follower:follower,following:following,isShora:isShora}
            this.setState({loaded: true});
        }
    }


    async componentDidMount() {
        document.body.style.direction = "full-page rtl";
        await  this.getLoad();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {       
        let b1=this.context.pageBWindow;
        let isLogined=this.context.isLoggedIn;
        if (isLogined && !this.customCaptionBar ) {
            if(b1.isCef) b1.CustomCaptionBar();
        }         
        this.customCaptionBar=isLogined;
    }

    render(){
        this.context.page=this.page;
        this.context.theme=this.state.theme;

        if (this.state.loaded) {
            if(this.callmode ==="iframe"){
                return (
                    <React.Fragment>
                          <Main /> 
                    </React.Fragment>
                );
            }
            return (
                <React.Fragment> 
                    <Helmet>
                        <title>{this.page.pageTitle.title}</title>
                    </Helmet> 
                    <SideBar logout={this.props.logout} />
                    <Alerts ref={this.pageAlerts}  animEnter="animated backInLeft" animExit="animated  backOutLeft"   />
                </React.Fragment>
            );
        }else{
            return (
                <Loading type="Chase" />
            );
        }
    }
} 
App.contextType = MCbrowser;
export default App;
